import { render, staticRenderFns } from "./BrandOrder.vue?vue&type=template&id=4b950100&scoped=true"
import script from "./BrandOrder.vue?vue&type=script&lang=js"
export * from "./BrandOrder.vue?vue&type=script&lang=js"
import style0 from "./BrandOrder.vue?vue&type=style&index=0&id=4b950100&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b950100",
  null
  
)

export default component.exports